import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Input } from "antd";
import { connect } from "react-redux";
import { requestServerPost, selectBrand, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import ColorPicker from "../ColorPicker";
import Colors from "../../config/Colors";
import { LayoutGrid } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

class CreateCampaignPage extends Component {
  constructor(props) {
    super(props);
    const { data = null } = props;
    const campaignName = data ? data.CampaignName : "";
    this.state = {
      campaignname: campaignName,
      data: data,
      color:
        data && data.CampaignColor
          ? data.CampaignColor
          : Colors.defaultcampaign,
    };
  }

  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
    } = this.props;
    var params = new FormData();

    if (!data) {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("campaignname", values.campaignname);
      params.append("campaigncolor", this.state.color);
      requestServerPost(
        "create_campaign",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    } else {
      params.append("campaignid", data.CampaignID);
      params.append("campaignname", values.campaignname);
      params.append("campaigncolor", this.state.color);
      requestServerPost(
        "update_campaign",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  onBackgroundColorChanged = (newcolor) => {
    this.setState({ color: newcolor });
  };

  render() {
    const { data = null } = this.props;
    const { campaignname, color } = this.state;
    const t = this.props.langT || PRO_TRANSLATIONS.en.createCampaignPopup;
    const isEdit = !!data;
    const nameReady = campaignname.trim().length > 0;

    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        {/* Gradient header */}
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <LayoutGrid size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {isEdit ? t.editTitle : t.createTitle}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {isEdit
              ? `${t.editingPrefix} "${data.CampaignName}"`
              : t.createSubtitle}
          </div>
        </div>

        {/* Body */}
        <div style={{ ...body }}>
          <Form
            name="create_campaign_form"
            {...formItemLayout}
            key={`${isEdit ? data.CampaignID + "_campaign_form" : "campaign_form"}`}
            onFinish={this.onFinish}
            initialValues={{ campaignname: this.state.campaignname }}
            onValuesChange={(_, all) =>
              this.setState({ campaignname: all.campaignname || "" })
            }
          >
            {/* Campaign name */}
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.nameLabel}
              </label>
              <Form.Item
                name="campaignname"
                key={`${isEdit ? data.CampaignID + "_cname" : "cname"}`}
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.nameRequired }]}
              >
                <Input
                  size="large"
                  placeholder={t.namePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>

            {/* Colour picker */}
            <div style={{ marginBottom: 28 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 10,
                }}
              >
                {t.colourLabel}
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <ColorPicker
                  color={color}
                  onColorChange={this.onBackgroundColorChanged}
                />
                <span
                  style={{
                    fontSize: 13,
                    color: "#64748b",
                    fontFamily: "monospace",
                  }}
                >
                  {color}
                </span>
              </div>
            </div>

            {/* Submit */}
            <Form.Item style={{ marginBottom: 0 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                  transition: "opacity 0.2s",
                }}
              >
                {isEdit ? t.saveButton : t.createButton}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedCreateCampaignPage = connect(mapStateToProps, {
  requestServerPost,
  selectPage,
})(CreateCampaignPage);

const CreateCampaignPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.createCampaignPopup ||
    PRO_TRANSLATIONS.en.createCampaignPopup;
  return <ConnectedCreateCampaignPage langT={t} {...props} />;
};

export default CreateCampaignPageWithLang;
